module.exports = __webpack_public_path__ + "static/media/background.e97ba1cb.png";